<template>
    <div>
        <h2>Response Dashboard:</h2>
        <b>{{caseData.title}}</b>
        <hr>
        <h3>Showing data from {{caseAttemptsRecorded}} attempts of this case.</h3>
        <ResponseDashboard :slideDeck="slideDeck" :responseData="responseData" :indicatorData="[]"/>
    </div>
</template>

<script>
    import APIRequests from "../APIRequests.js"
    import ResponseDashboard from "../classrooms/ResponseDashboard.vue"
    
    export default {
        components: {
            ResponseDashboard
        },
        props: {
            caseID: {
                type: String
            },
        },
        data: function(){
            return {
                caseData: {},
                slideDeck: {},
                responseData: [],
                caseAttemptsRecorded: 0,
                editorMode: false,
            }
        },
        methods: {
            getResponses: function(){
                var api_url = this.$store.state.api_url + "/api/editor/" + this.caseID + "/responses"
                return APIRequests.getJSONData(
                    api_url, 
                    this.$store.state.jwtToken
                ).then((data) => {
                    if(!data) data=[]
                    this.responseData = data
                    let caseAttempts = {}
                    this.responseData.forEach((responseEntry) => {
                        caseAttempts[responseEntry.pid + "-" + responseEntry.attempt] = true
                    })
                    this.caseAttemptsRecorded = Object.keys(caseAttempts).length
                })
            },
            fetchCase: function () {
				var api_url = this.$store.state.api_url + "/api/cases/" + this.caseID
				return APIRequests.getJSONData(api_url, this.$store.state.jwtToken).then((data) => {
                    if(this.$store.state.jwtClaims){
						var isCreator = this.$store.state.jwtClaims.id == data.creatorID
						var isEditor = data.editorList.includes(this.$store.state.jwtClaims.id)
						if(isCreator || isEditor){
                            this.caseData = data;
                            return
						}
                    }
                    this.$router.replace("/")
				})
            },
            createSlideDeck: function(){
				var slideDeck = {}
				var collectSlides = function(activityObj, activityName){
					for (var i in activityObj) {
						var entry = activityObj[i]
						entry.type = activityName
						//entry.complete = false
						slideDeck[entry.slide.order] = entry
					}
				}
				collectSlides(this.caseData.history, "History")
				collectSlides(this.caseData.physical_exams, "Physical Exam")
				collectSlides(this.caseData.labs, "Labs")
				collectSlides(this.caseData.sa_questions, "Short Answer")
				collectSlides(this.caseData.mc_questions, "Multiple Choice")
				collectSlides(this.caseData.ck_questions, "Checklist")
				collectSlides(this.caseData.ddx_questions, "Diagnosis")
				collectSlides(this.caseData.education, "Education")
				this.slideDeck = slideDeck
			},
        },
        mounted: function(){
            this.$nextTick(function () {
                this.fetchCase().then(() => {
                    this.createSlideDeck()
                    this.getResponses()
                })
            })
        }
    }
</script>

<style scoped>
    .header-links {
        display: flex;
        justify-content: space-around;
        max-width: 500px;
        margin: auto;
        margin-top: 24px;
    }
    .header-links a {
        color: black !important;
        font-weight: bold;
    }
</style>
